import http from "~/composables/http.js";

export const IMAGE_TO_IMAGE_TASK_TYPE = "image-to-image";
export const NANO_BANANA_2_MODEL = "nano-banana-2";

export function createImageGenerationTask(data) {
  return http.post("/api/aigc/image/v1/image-generation/create-task", data);
}

export function getImageGenerationTaskResult(params) {
  return http.get("/api/aigc/image/image-generation/get-task-result", params);
}

export function getImageGenerationHistory({
  page = 1,
  size = 16,
  task_type = IMAGE_TO_IMAGE_TASK_TYPE,
} = {}) {
  return http.get("/api/aigc/image/image-generation/get-history", {
    page,
    size,
    task_type,
  });
}

export function deleteImageGenerationTask(data) {
  return http.post("/api/aigc/image/image-generation/delete-task", data);
}
